import { render, staticRenderFns } from "./integral-exchange.vue?vue&type=template&id=073c2950&"
import script from "./integral-exchange.vue?vue&type=script&lang=js&"
export * from "./integral-exchange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports